__turbopack_context__.v({
  "control": "Label-module__3PlYOa__control",
  "disabled": "Label-module__3PlYOa__disabled",
  "label": "Label-module__3PlYOa__label",
  "large": "Label-module__3PlYOa__large",
  "required": "Label-module__3PlYOa__required",
  "small": "Label-module__3PlYOa__small",
});
